<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $t('addFunds') }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-title v-if="!hasCreditTypes">
            {{ $t('noCreditTypes') }}
          </v-card-title>
        </v-card>

        <v-tabs slider-color="primary" centered class="elevation-1" v-if="hasCreditTypes">
          <v-tab v-if="isPaypalActive">
            PayPal
          </v-tab>
          <v-tab ripple v-if="hasBankAccounts">
            {{ $t('transfer') }}
          </v-tab>
          <v-tab ripple v-if="isOpenpayActive">
            {{ $t('creditCard') }}
          </v-tab>
          <v-tab ripple v-if="isOpenpayActive">
            SPEI
          </v-tab>
          <v-tab ripple v-if="isOpenpayActive">
            Tiendas
          </v-tab>
          <v-tab ripple v-if="isMercadoPagoActive">
            Mercado Pago
          </v-tab>

          <v-tab-item v-if="isPaypalActive">
            <PayPal></PayPal>
          </v-tab-item>

          <v-tab-item v-if="hasBankAccounts">
            <BankAccounts :bankAccounts="bankAccounts" :settings="settings"></BankAccounts>
          </v-tab-item>

          <v-tab-item v-if="isOpenpayActive">
            <OpenpayCard :settings="settings"></OpenpayCard>
          </v-tab-item>

          <v-tab-item v-if="isOpenpayActive">
            <OpenpayBank :settings="settings"></OpenpayBank>
          </v-tab-item>

          <v-tab-item v-if="isOpenpayActive">
            <OpenpayStore :settings="settings"></OpenpayStore>
          </v-tab-item>

          <v-tab-item v-if="isMercadoPagoActive">
            <MercadoPago></MercadoPago>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Setting from '@/client/setting'
import BankAccount from '@/client/bank-account'

import PayPal from '@/components/funds/paypal.vue'
import BankAccounts from '@/components/funds/bank-accounts.vue'
import OpenpayCard from '@/components/funds/openpay/card'
import OpenpayBank from '@/components/funds/openpay/bank'
import OpenpayStore from '@/components/funds/openpay/store'
import MercadoPago from '@/components/funds/mercado-pago'

export default {
  name: 'AddFundsView',

  props: {},

  data () {
    return {
      settings: [],
      bankAccounts: []
    }
  },

  components: {
    PayPal,
    BankAccounts,
    OpenpayCard,
    OpenpayBank,
    OpenpayStore,
    MercadoPago
  },

  computed: {
    hasCreditTypes () {
      return this.isPaypalActive || this.hasBankAccounts || this.hasPaymentEngine || this.isMercadoPagoActive
    },

    showBankAccounts () {
      if (!this.settings) { return false }

      const setting = this.settings.find(o => o.key === 'show_bank_accounts') || {}
      return setting.value === '1'
    },

    hasBankAccounts () {
      return this.bankAccounts.length > 0 && this.showBankAccounts
    },

    isPaypalActive () {
      if (!this.settings) { return }

      const paypal = this.settings.find(o => o.key === 'paypal') || {}
      return paypal.value === '1'
    },

    hasPaymentEngine () {
      if (!this.settings) { return }

      const engine = this.settings.find(o => o.key === 'payment_engine') || {}
      return engine.value !== '0'
    },

    isOpenpayActive () {
      if (!this.settings) { return }

      const engine = this.settings.find(o => o.key === 'payment_engine') || {}
      return engine.value === 'OpenPay'
    },

    isMercadoPagoActive () {
      if (!this.settings) { return }

      const engine = this.settings.find(o => o.key === 'mercado_pago') || {}
      return engine.value === '1'
    }
  },

  methods: {
  },

  watch: {
  },

  async mounted () {
    let mercadoScript = document.createElement('script')
    mercadoScript.setAttribute('src', 'https://sdk.mercadopago.com/js/v2')
    document.head.appendChild(mercadoScript)

    this.settings = await Setting.all()
    this.bankAccounts = await BankAccount.all()

  }
}
</script>
